import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import brands from './brands'
import flair from './flair'
import oldMarkets from './old-markets'
import languages from './languages'
import sites from './sites'
import content from './content'
import months from './months'
import task from './task'
import type from './type'
import status from './status'
import market from './market'
import notifications from './notifications'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    brands,
    flair,
    oldMarkets,
    languages,
    sites,
    content,
    months,
    task,
    type,
    status,
    market,
    notifications,
  },
})

export default store
